import { Conjoint } from "./model.conjoint";
import { Irrecevabilite } from "./irrecevabilite";
import { Rejet } from "./rejet";

export class Addrembrs{
    /*id:any=null;
    numero:number;
    nom:string="";
    prenom:string="";
    service:string="";
    telephone:number;
    mail:string="";
    nom_patient:string="";
    type_patient:string="";
    be:string="";
    demande:string="";
    bc:string="";
    ordonnance:string="";
    facture:string="";
    notice:string="";
    avis_credit:string="";
    billet_hopital:string="";
    bulletin_naissance:string="";
    acte_mariage:string="";
    acte_deces:string="";
    acte_notoriete:string="";
    cin:string="";
    rib:string="";
    date_validation:Date;
    num_rejet:String="";
    date:Date;
    num_be:number;
    date_be:Date;
    num_dossier:number;
    date_dossier:Date;
    matricule:String="";
    motif:String="";
    date_retour:Date;
    date_enregistrement:Date;
    motif_rembrs:String;
    num_enregistrement:number;
    objet_remboursement:String="";
    prescripteur:String="";
    date_consultation:Date;
    etablissement:String="";
    debut_hospitalisation:Date;
    fin_hospitalisation:Date;
    type_hospitalisation:String="";
    montant:String="";
    rens_clinique:String="";
    date_engagement:Date;*/
        id:any=null;
    numero:number;
    nom:string="";
    prenom:string="";
    service:string="";
    telephone:number;
    mail:string="";
    nom_patient:string="";
    type_patient:string="";
    be:string="";
    demande:string="";
    nbr_demande:string="";
    bc:string="";
    nbr_bc:string="";
    ordonnance:string="";
    nbr_ordonnance:string="";
    facture:string="";
    nbr_facture:string="";
    notice:string="";
    nbr_notice:string="";
    avis_credit:string="";
    nbr_avis_credit:string="";
    billet_hopital:string="";
    nbr_billet_hopital:string="";    
    bulletin_naissance:string="";
    nbr_bulletin_naissance:string="";
    acte_mariage:string="";
    nbr_acte_mariage:string="";
    acte_deces:string="";
    nbr_acte_deces:number;
    acte_notoriete:string="";
    nbr_acte_notoriete:string="";
    cin:string="";
    nbr_cin:number;
    rib:string="";
    nbr_rib:number;
    date_validation:Date;
    num_rejet:String="";
    date:Date;
    num_be:String;
    date_be:Date;
    num_dossier:number;
    date_dossier:Date;
    matricule:String="";
    motif:String="";
    date_retour:Date;
    date_enregistrement:Date;
    motif_rembrs:String;
    num_enregistrement:String;
    objet_remboursement:String="";
    prescripteur:String="";
    date_consultation:Date;
    etablissement:String="";
    debut_hospitalisation:Date;
    fin_hospitalisation:Date;
    type_hospitalisation:String="";
    montant:String="";
    rens_clinique:String="";
    date_engagement:Date;
    nbr_attestation_vente : number;
    attestation_vente : String;
    engager_numero : String;
    engager_decision : String;
    engager_date_saisie : String;
conjoints_id:number;
conjoints : Conjoint;
enregistrer : Addrembrs;
annee : any;
objet_remboursement_code : String;
motif_rejet : String;
motif_rejet_admin  : String;
motif_rejet_med : String ;
motif_rejet_chef : String;
nbr_procuration: number;

nbr_piece_just :number;
nbr_etat_recap : number;

listeInfoRembourses : any;
beneficiaires :Array<Conjoint>=new Array<Conjoint>();
rembourse : Addrembrs;

    date_debut  : Date;
    date_fin : Date;


rembourse_etat_mdc : String;
rembourse_etat_adm : String;
livret_famille:String="";
nbr_livret_famille: number;
ticket:String="";
nbr_ticket: number;
attestation_paiement:String="";
nbr_attestation_paiement: number;
photocopie_dossier:String="";
nbr_photocopie_dossier: number;
autre_piece:String="";
employer_id : number;
irrecevabilites :Array<Irrecevabilite>=new Array<Irrecevabilite>();;
rejets :Array<Rejet>=new Array<Rejet>();
checked : boolean;
strDateDebut : String="";
strDateFin : String="";

validateur_medicale_id : number;
validateur_adm_id : number;
validateur_chef_id : number;
        constructor(){

            this.conjoints=new Conjoint(null);
        }
}